export const tipoAjusteVencimentoEnum = {
    ANTECIPAR: 1,
    PRORROGAR: 2
}